"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseShareAppActionYamlConfig = void 0;
const tslib_1 = require("tslib");
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const adm_zip_1 = tslib_1.__importDefault(require("adm-zip"));
const fs_extra_1 = tslib_1.__importDefault(require("fs-extra"));
const path_1 = tslib_1.__importDefault(require("path"));
const localizeUtils_1 = require("../../../common/localizeUtils");
const lifecycle_1 = require("../../configManager/lifecycle");
const envUtil_1 = require("../../utils/envUtil");
const metadataUtil_1 = require("../../utils/metadataUtil");
const pathUtils_1 = require("../../utils/pathUtils");
const acquire_1 = require("../m365/acquire");
const constants_1 = require("../teamsApp/constants");
// Read m365agents.yaml and get the value of shared title id, and shared app id
async function parseShareAppActionYamlConfig(projectPath) {
    var _a, _b, _c, _d, _e;
    const templatePath = pathUtils_1.pathUtils.getYmlFilePath(projectPath, "dev");
    const maybeProjectModel = await metadataUtil_1.metadataUtil.parse(templatePath);
    if (maybeProjectModel.isErr()) {
        return (0, teamsfx_api_1.err)(maybeProjectModel.error);
    }
    const projectModel = maybeProjectModel.value;
    if ((!projectModel.provision || !projectModel.provision.driverDefs) &&
        (!projectModel.deploy || !projectModel.deploy.driverDefs)) {
        return (0, teamsfx_api_1.err)(new teamsfx_api_1.UserError("FxCore", "Share", (0, localizeUtils_1.getLocalizedString)("error.share.yamlConfigNotFound")));
    }
    const extendToM365Action = ((_a = projectModel.provision) === null || _a === void 0 ? void 0 : _a.driverDefs.find((d) => d.uses === acquire_1.actionName)) ||
        ((_b = projectModel.deploy) === null || _b === void 0 ? void 0 : _b.driverDefs.find((d) => d.uses === acquire_1.actionName));
    if (!extendToM365Action) {
        return (0, teamsfx_api_1.err)(new teamsfx_api_1.UserError("FxCore", "Share", (0, localizeUtils_1.getLocalizedString)("error.share.shareActionConfigNotFound", acquire_1.actionName)));
    }
    // 1. get manifest id
    const appPackagePath = (_c = extendToM365Action.with) === null || _c === void 0 ? void 0 : _c.appPackagePath;
    if (!appPackagePath) {
        return (0, teamsfx_api_1.err)(new teamsfx_api_1.UserError("FxCore", "Share to Users", (0, localizeUtils_1.getLocalizedString)("error.share.appPackageConfigNotFound")));
    }
    const readEnvRes = await envUtil_1.envUtil.readEnv(projectPath, "dev");
    if (readEnvRes.isErr()) {
        return (0, teamsfx_api_1.err)(readEnvRes.error);
    }
    const resolvedDriver = (0, lifecycle_1.resolve)(extendToM365Action, [], []);
    const resolvedAppPackagePath = path_1.default.resolve(projectPath, resolvedDriver.with.appPackagePath);
    if (!fs_extra_1.default.existsSync(resolvedAppPackagePath)) {
        return (0, teamsfx_api_1.err)(new teamsfx_api_1.UserError("FxCore", "Share", (0, localizeUtils_1.getLocalizedString)("error.share.appPackageNotFound", resolvedAppPackagePath)));
    }
    const zipEntries = new adm_zip_1.default(resolvedAppPackagePath).getEntries();
    const manifestFile = zipEntries.find((x) => x.entryName === constants_1.Constants.MANIFEST_FILE);
    if (!manifestFile) {
        return (0, teamsfx_api_1.err)(new teamsfx_api_1.UserError("FxCore", "Share to Users", (0, localizeUtils_1.getLocalizedString)("error.share.manifestFileNotFound")));
    }
    const manifest = JSON.parse(manifestFile.getData().toString());
    const manifestId = manifest.id;
    if (!manifestId) {
        return (0, teamsfx_api_1.err)(new teamsfx_api_1.UserError("FxCore", "Share to Users", (0, localizeUtils_1.getLocalizedString)("error.share.manifestIdNotFound")));
    }
    // 2. get shared title id and shared app id
    const sharedTitleIdEnvName = (_d = extendToM365Action.writeToEnvironmentFile) === null || _d === void 0 ? void 0 : _d.titleId;
    const sharedAppIdEnvName = (_e = extendToM365Action.writeToEnvironmentFile) === null || _e === void 0 ? void 0 : _e.appId;
    if (!sharedTitleIdEnvName || !sharedAppIdEnvName) {
        return (0, teamsfx_api_1.err)(new teamsfx_api_1.UserError("FxCore", "Share", (0, localizeUtils_1.getLocalizedString)("error.share.sharedConfigNotFound")));
    }
    // env file has already been loaded before calling this function.
    const sharedTitleId = process.env[sharedTitleIdEnvName];
    const sharedAppId = process.env[sharedAppIdEnvName];
    if (!sharedTitleId || !sharedAppId) {
        return (0, teamsfx_api_1.err)(new teamsfx_api_1.UserError("FxCore", "Share", (0, localizeUtils_1.getLocalizedString)("error.share.sharedIdNotFound", sharedTitleId, sharedAppId)));
    }
    return (0, teamsfx_api_1.ok)({ teamsappId: manifestId, titleId: sharedTitleId, appId: sharedAppId });
}
exports.parseShareAppActionYamlConfig = parseShareAppActionYamlConfig;
//# sourceMappingURL=utils.js.map